import { EditNotifications } from "@mui/icons-material";
import {
  Box,
  Button,
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useDynamicPagesContext } from "../../../../context/dynamic-pages-context";
import ResponsiveDialog from "../../../../components/modal/prompt";
import UpdateTypesForm from "./updateTypesForm";
import AddTypesForm from "./addTypesForm";

const AddDynamicPageTypes = () => {
  const [showForm, setShowForm] = useState(false);
  const [addTypesModal, setAddTypesModal] = useState(false);

  const [typesData, setTypesData] = useState({
    title: "",
    description: "",
  });
  const [modalData, setModalData] = useState();

  const { addTypes, types } = useDynamicPagesContext();

  const storeTypes = async () => {
    if (!typesData.title.trim()) {
      alert("Title is required");
      return;
    }

    if (!typesData.description.trim()) {
      alert("Description is required");
      return;
    }

    const response = await addTypes(typesData);

    console.log(response, "response");
  };

   return (
    <Box width={500}>
      <Button onClick={() => setAddTypesModal(true)}>Add Types</Button>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Title</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {types?.map((type) => (
              <TableRow key={type.id}>
                <TableCell>{type.title}</TableCell>
                <TableCell>{type.description}</TableCell>
                <TableCell>
                  <IconButton
                    onClick={() => {
                      setShowForm(true);
                      setModalData(type);
                    }}
                  >
                    <EditNotifications />
                  </IconButton>
                  <IconButton>{/* <DeleteIcon /> */}</IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <ResponsiveDialog
        modalOpen={showForm}
        setModalOpen={setShowForm}
        form={<UpdateTypesForm dataSingle={modalData} />}
        title={"Add Types"}
        cancelButtonText={"cancel"}
        submitButtonText={" "}
        size="lg"
      />

      <ResponsiveDialog
        modalOpen={addTypesModal}
        setModalOpen={setAddTypesModal}
        form={<AddTypesForm />}
        title={"Add Types"}
        cancelButtonText={"cancel"}
        submitButtonText={" "}
        size="lg"
      />
    </Box>
  );
};

export default AddDynamicPageTypes;
